import styled from 'styled-components';

export const Fields = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;

  .ant-picker {
    width: 100%;
  }
`;
